import { Navigate } from 'react-router-dom';
import { ProtectedRouteProps } from './types';
import { useStore } from '@hooks/useStore';
import { AuthSessionGate } from './AuthSessionGate';

const Protected = ({ permissions, element }: ProtectedRouteProps) => {
  const { authStore } = useStore();
  const { hasPermission } = authStore;

  return (
    <AuthSessionGate>
      {hasPermission(permissions) ? (
        element ?? null
      ) : (
        <Navigate to="/dashboard" replace />
      )}
    </AuthSessionGate>
  );
};

export default Protected;
